import { HelpGuideIcon } from './helpIcons';
import styles from './GuideIconTile.module.css';

interface IGuideIconTileProps {
  iconKey: string;
  /**
   * - `card`: the tinted 40px square on a guide card
   * - `head`: the 48px tinted square beside a guide's title
   * - `kid`: the small outlined 30px square on a report row, search hit or report card
   */
  variant: 'card' | 'head' | 'kid';
}

const ICON_SIZE = { card: 20, head: 22, kid: 16 } as const;

/** The rounded square a guide's icon sits in, shared by the hub and the reader. */
export function GuideIconTile({ iconKey, variant }: IGuideIconTileProps) {
  return (
    <span className={`${styles.tile} ${styles[variant]}`}>
      <HelpGuideIcon iconKey={iconKey} size={ICON_SIZE[variant]} />
    </span>
  );
}
